import { render } from "./MainFooterComponent.vue?vue&type=template&id=959d64a0&scoped=true"
const script = {}

import "./MainFooterComponent.vue?vue&type=style&index=0&id=959d64a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-959d64a0"]])

export default __exports__